// Libraries
import { action, computed, observable } from "mobx";

// Core
import { ModelBase } from "Core/Models/ModelBase";

// Custom
import { Delcote25Model, Delcote25ModelDTO } from "./DelcoteProductModels/Delcote25";
import { Delcote10Model, Delcote10ModelDTO } from "./DelcoteProductModels/Delcote10";
import { DelcoteAsbestosModel, DelcoteAsbestosModelDTO } from "./DelcoteProductModels/DelcoteAsbestos";

export class DelcoteProductsModel extends ModelBase<DelcoteProductsModel, DelcoteProductsModelDTO> {
    private delcote10Model: Delcote10Model;
    private delcote25Model: Delcote25Model;
    private delcoteAsbestosModel: DelcoteAsbestosModel;

    constructor() {
        super();
        this.delcote10Model = new Delcote10Model();
        this.delcote25Model = new Delcote25Model();
        this.delcoteAsbestosModel = new DelcoteAsbestosModel();

        this.products.push({
            title:
                "Delcote 10 Metal roof coating – Single coat 10 Year System Guarantee (<a href='https://www.hdsharman.co.uk/wp-content/uploads/2020/10/Delcote-10-Metal-Roof-Coating-Specification-V4-Jun2021-1.pdf' target='_blank'>view system specification</a>)",
            value: "id_delcotesubstratemetal10",
        });

        this.products.push({
            title:
                "Delcote 25 Metal roof coating – Dual coat 25 Year System Guarantee (<a href='https://www.hdsharman.co.uk/wp-content/uploads/2020/10/Delcote-25-Metal-Roof-Coating-Specification-2020.pdf' target='_blank'>view system specification</a>)",
            value: "id_delcotesubstratemetal25",
        });

        this.products.push({
            title:
                "Delcote 25 Fibre cement roof coating – Dual coat 25 Year System Guarantee (<a href='https://www.hdsharman.co.uk/wp-content/uploads/2023/05/Delcote-25-Asbestos-Cement-Roof-Coating-Specification-2020_.pdf' target='_blank'>view system specification</a>)",
            value: "id_delcotesubstratefibrecement",
        });

        // this.productSelection = this.products[1]; // Delcote 25 Metal
    }

    // #region Model Properties

    public get Delcote10Model(): Delcote10Model {
        return this.delcote10Model;
    }

    public get Delcote25Model(): Delcote25Model {
        return this.delcote25Model;
    }

    public get DelcoteAsbestosModel(): DelcoteAsbestosModel {
        return this.delcoteAsbestosModel;
    }

    @observable
    public products = observable<any>([]);

    @observable
    private productSelection: any = undefined;

    @computed
    public get getProductSelection(): any {
        return this.productSelection;
    }

    @action
    public setProductSelection = (value: any) => {
        this.productSelection = value;
    };

    // #endregion Model Properties

    public fromDto(model: DelcoteProductsModelDTO): void {
        throw new Error("Method not implemented.");
    }

    public toDto(): DelcoteProductsModelDTO {
        return {
            delcote10: this.productSelection.value === "id_delcotesubstratemetal10" ? this.Delcote10Model.toDto() : undefined,
            delcote25: this.productSelection.value === "id_delcotesubstratemetal25" ? this.Delcote25Model.toDto() : undefined,
            delcoteAsbestos: this.productSelection.value === "id_delcotesubstratefibrecement" ? this.DelcoteAsbestosModel.toDto() : undefined,
        };
    }
}

export interface DelcoteProductsModelDTO {
    delcote10?: Delcote10ModelDTO;
    delcote25?: Delcote25ModelDTO;
    delcoteAsbestos?: DelcoteAsbestosModelDTO;
}
